<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sc-imWYAI bDmLHg">
    <path d="m12 17.092-8.061-8.06L6.061 6.91 12 12.85l5.939-5.94 2.122 2.122L12 17.092Z" class="fill-current"></path>
  </svg>
</template>
